export default __webpack_public_path__ + "media/images/down_16-d9d02c9c64316f5b7f043afd16487af9.png";